import Grid from "@mui/material/Grid2";
import { FormContainer, useForm } from "react-hook-form-mui";
import { useContext, useEffect, useState } from "react";
import { APIContext } from "../Contexts/APIContext";
import SettingsViewModel from "./ViewModels/SettingsViewModel";
import ValidatedCheckBoxElement from "../Utilities/Forms/ValidatedCheckBoxElement";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

export default function Settings() {
    const { get, post, showMessage, loading } = useContext(APIContext);

    const [settings, setSettings] = useState<SettingsViewModel>(new SettingsViewModel());

    const formContext = useForm<SettingsViewModel>({
        defaultValues: settings,
    });
    const { reset } = formContext;

    useEffect(() => {
        getData();
    }, []);


    useEffect(() => {
        if (settings) {
            reset(settings);
        }
    }, [settings, reset]);
    const getData = async () => {
        get("UserSettings", `GetUserSettingsPage`, setSettings);
    }

    const submit = async (form: any) => {
        await post("UserSettings", `SaveUserPageSettings`, form, checkCloseDialog);
    }

    const checkCloseDialog = async (success: boolean = true) => {
        if (success) {
            showMessage('success', 'User has been updated');
        }
    }


    return (
        <Container maxWidth="md" fixed>
            <Grid container>
                <Grid size={12}>
                    <Typography variant="h4">User Settings</Typography>
                </Grid>
                <Grid size={12} component={Paper}>
                    <FormContainer
                        formContext={formContext}
                        onSuccess={submit}
                    >
                        <Grid container>
                            <Grid size={12}>
                                <ValidatedCheckBoxElement name={"partTimeFactor"} label="Part Time Employees count as 0.5" disabled={loading} />
                            </Grid>
                            <Grid size={12}>
                                <ValidatedCheckBoxElement name={"includeGFANotInUse"} label="Include GFA not in use in GFA trip rate calculations" disabled={loading} />
                            </Grid>
                            <Grid size={8} />
                            <Grid size={4}>
                                <Button type="submit">
                                    Save
                                </Button>
                            </Grid>
                        </Grid>

                    </FormContainer>
                </Grid>
            </Grid>
        </Container>
    );
}
